import { useMemo } from 'react'

export const useTourRoutesURL = (route: string) => {
  const isWalletsRoute = useMemo(
    () => !!route.match(/^\/[^/]+\/dashboard\/traders-room\/wallets\/?$/),
    [route]
  )

  const isTradingAccountsRoute = useMemo(
    () => !!route.match(/^\/[^/]+\/dashboard\/traders-room\/trading-accounts\/live\/?$/),
    [route]
  )
  return { isWalletsRoute, isTradingAccountsRoute }
}
